import { render, staticRenderFns } from "./Carrello.vue?vue&type=template&id=a9745438&scoped=true&"
import script from "./Carrello.vue?vue&type=script&lang=js&"
export * from "./Carrello.vue?vue&type=script&lang=js&"
import style0 from "./Carrello.vue?vue&type=style&index=0&id=a9745438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9745438",
  null
  
)

export default component.exports